import Panel from "./Panel.js"
import Home from "./captionsettings/Home"
import Options from "./captionsettings/Options"
import BackgroundColor from "./captionsettings/BackgroundColor"
import BackgroundOpacity from "./captionsettings/BackgroundOpacity"
import CharacterEdgeStyle from "./captionsettings/CharacterEdgeStyle"
import FontColor from "./captionsettings/FontColor"
import FontFamily from "./captionsettings/FontFamily"
import FontOpacity from "./captionsettings/FontOpacity"
import FontSize from "./captionsettings/FontSize"
import WindowColor from "./captionsettings/WindowColor"
import WindowOpacity from "./captionsettings/WindowOpacity"
import ScrollType from "./captionsettings/ScrollType"
import EdgeColor from "./captionsettings/EdgeColor"
import EdgeOpacity from "./captionsettings/EdgeOpacity"
import Color from "./captionsettings/Color"
import CaptionData from "./CaptionData"

export default class CaptionSettings extends Panel {

  constructor(props, context) {
    super(props, context)
    this.state.languages = []
    this.state.keyDown = false

    const settings = Object.assign({}, this.player.settings.captions)
    delete settings.track

    for (let key in settings) {
      if (/Color$/.test(key)) {
        settings[key] = new Color(settings[key])
        settings[key.replace("Color", "Opacity")] = settings[key].a
      }
    }
    this.state.captionsettings = settings

    this.state.viewChange = this.changeView.bind(this)
    this.state.settingsChange = this.changeSettings.bind(this)
    this.state.level = "home"

    this.state.labels = new CaptionData()

    this.initSettingLabels()
  }

  static get contextTypes() {
    return super.contextTypes
  }

  componentWillMount() {
    this.open = true
  }

  focus(event) {
    this.refs.element.firstChild.children[2].focus()
  }

  changeView(event, toState) {
    if (/keydown/.test(event.type) && (event.keyCode == 13 || event.keyCode == 32 || event.keyCode == 37 || event.keyCode == 39)) {
      this.keyDown = true
    }
    setTimeout(() => { this.setState({level: toState}) }, 100)
  }

  initSettingLabels() {
    for (let key in this.state.labels) {
      this.state.labels[key].forEach((item) => {
        if ((/color/i.test(key) && (item.value.r == this.state.captionsettings[key].r && item.value.g == this.state.captionsettings[key].g && item.value.b == this.state.captionsettings[key].b)) ||
            (/opacity/i.test(key) && (item.value == this.state.captionsettings[key.replace("Opacity", "Color")].a)) ||
            (this.state.captionsettings[key] == item.value)) {
              this.state.captionsettings[`${key}Label`] = item.label
            }
      })
    }
  }

  changeSettings(object) {
    for (var key in object) {
      let setting = object[key]
      let value = setting.value
      switch (key) {
        case "language":
          const hidden = (setting.value == "off")
          if (!hidden)
            this.player.captioning.selectTrackByLanguage(setting.value)
          this.player.captioning.hidden = hidden
        break

        case "backgroundColor":
        case "windowColor":
        case "fontColor":
        case "edgeColor":
          value.a = this.state.captionsettings[key].a
        break

        case "backgroundOpacity":
        case "fontOpacity":
        case "windowOpacity":
        case "edgeOpacity":
          let color = this.state.captionsettings[key.replace("Opacity", "Color")]
          color.a = value
          value = color
        break

      }
      this.state.captionsettings[key.replace("Opacity", "Color")] = value
      this.state.captionsettings[`${key}Label`] = setting.label
    }

    let settings = Object.assign({}, this.state.captionsettings)
    for (let key in settings) {
      if (/Label$/.test(key) || /Opacity$/.test(key) || /language/.test(key)) {
        delete settings[key]
      }
      else if (/Color$/.test(key)) {
        settings[key] = settings[key].toString()
      }
    }
    settings.visible = !this.player.captioning.hidden
    this.player.captioning.changeSettings(settings)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.keyDown) {
      this.refs.element.firstChild.children[1].focus()
      this.keyDown = false
    }
  }

  getCurrentPage() {

    switch (this.state.level) {
      case "home":
        return <Home {...this.state} gotoSettings={this.props.gotoSettings.bind(this)}/>
        break
      case "options":
        return <Options {...this.state}/>
        break
      case "fontFamily":
        return <FontFamily {...this.state}/>
        break
      case "fontColor":
        return <FontColor {...this.state}/>
        break
      case "size":
        return <FontSize {...this.state}/>
        break
      case "fontOpacity":
        return <FontOpacity {...this.state}/>
        break
      case "backgroundColor":
        return <BackgroundColor {...this.state}/>
        break
      case "backgroundOpacity":
        return <BackgroundOpacity {...this.state}/>
        break
      case "windowColor":
        return <WindowColor {...this.state}/>
        break
      case "windowOpacity":
        return <WindowOpacity {...this.state}/>
        break
      case "edgeType":
        return <CharacterEdgeStyle {...this.state}/>
        break
      case "edgeColor":
        return <EdgeColor {...this.state}/>
        break
      case "edgeOpacity":
        return <EdgeOpacity {...this.state}/>
        break
      case "scroll":
        return <ScrollType {...this.state}/>
    }
  }

  render() {
    return <div ref="element" role="menu">{this.getCurrentPage()}</div>
  }
}
